var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.271,67.802H54.352c-0.652-2.065-2.286-3.699-4.352-4.352v-5.261c10.476-0.419,20.906-4.115,20.906-10.632V30.213 c0-6.932-11.802-10.672-22.906-10.672s-22.906,3.74-22.906,10.672v17.344c0,6.517,10.43,10.213,20.906,10.632v5.261 c-2.066,0.652-3.7,2.286-4.352,4.352H23.729c-1.104,0-2,0.896-2,2s0.896,2,2,2h17.92c0.851,2.696,3.376,4.657,6.351,4.657 s5.5-1.961,6.352-4.657h17.919c1.104,0,2-0.896,2-2S73.375,67.802,72.271,67.802z M48,23.541c11.541,0,18.906,3.952,18.906,6.672 c0,2.72-7.365,6.672-18.906,6.672s-18.906-3.952-18.906-6.672C29.094,27.492,36.459,23.541,48,23.541z M29.094,47.557V36.429 C33.495,39.352,40.89,40.885,48,40.885c7.109,0,14.505-1.533,18.906-4.456v11.128c0,2.72-7.365,6.672-18.906,6.672 S29.094,50.277,29.094,47.557z M48,72.459c-1.466,0-2.658-1.192-2.658-2.657c0-1.466,1.192-2.658,2.658-2.658 s2.658,1.192,2.658,2.658C50.658,71.267,49.466,72.459,48,72.459z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.e19d35ad72897cd1fde4d261146f0db5.svg";
export { ForwardRef as ReactComponent };